import { useState } from "react";
import { WaitlistButton } from "./WaitlistButton";

const STORAGE_KEY = "waitlist_email";

export function HeroContent() {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  const [email, setEmail] = useState(stored ?? "");
  const [submitted, setSubmitted] = useState(!!stored);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbzY8L_Jb0aJXyZnp56_Ypoml4T8UADbK9CW7lAoUXx858qgofeJ0kbWOrmi1zPZqGLo/exec",
        {
          method: "POST",
          body: JSON.stringify({ email }),
        },
      );
      sessionStorage.setItem(STORAGE_KEY, email);
      setSubmitted(true);
    } catch {
      alert("Something went wrong — try again.");
    }
    setLoading(false);
  };

  return (
    <div className="relative z-20 flex flex-col items-center text-center px-6 py-24">
      <div className="flex flex-col items-center" style={{ gap: "40px" }}>
        {/* Badge pill */}
        <div
          className="flex items-center gap-2"
          style={{
            padding: "8px 16px",
            background: "rgba(255,255,255,0.1)",
            border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: "20px",
          }}
        >
          <div className="h-1 w-1 rounded-full bg-white" />
          <span style={{ fontSize: "13px" }} className="font-medium text-white/60">
            Early access available soon
          </span>
        </div>

        {/* Heading */}
        <h1
          className="font-medium"
          style={{
            fontSize: "clamp(36px, 5vw, 56px)",
            lineHeight: 1.28,
            maxWidth: "613px",
            background: "linear-gradient(144.5deg, #ffffff 28%, rgba(0,0,0,0) 115%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          1Password for AI Agents
        </h1>

        {/* Subtitle */}
        <p
          className="font-normal"
          style={{
            fontSize: "15px",
            color: "rgba(255,255,255,0.7)",
            maxWidth: "680px",
            marginTop: "-16px",
          }}
        >
          Store your secrets in passkeep. Give your OpenClaw agent a single API
          key and a skill — it pulls only what it needs, when it needs it.
        </p>

        {/* Email capture or success */}
        {submitted ? (
          <div
            className="flex flex-col items-center gap-3 animate-fade-in"
            style={{ animation: "fadeInUp 0.5s ease-out" }}
          >
            {/* Checkmark circle */}
            <div
              className="flex items-center justify-center rounded-full"
              style={{
                width: "48px",
                height: "48px",
                background: "rgba(74, 222, 128, 0.15)",
                border: "1px solid rgba(74, 222, 128, 0.4)",
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgb(74, 222, 128)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <p className="font-medium text-white" style={{ fontSize: "17px" }}>
              You're on the waitlist!
            </p>
            <p style={{ fontSize: "14px", color: "rgba(255,255,255,0.55)", maxWidth: "340px" }}>
              We'll send early access details to <span className="text-white/80">{email}</span>. Keep an eye on your inbox.
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col items-center gap-4 sm:flex-row"
          >
            <input
              type="email"
              required
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-[46px] rounded-full bg-transparent px-6 text-sm text-white placeholder:text-white/30 outline-none"
              style={{
                width: "280px",
                border: "0.6px solid rgba(255,255,255,0.3)",
                fontSize: "14px",
              }}
            />
            <WaitlistButton loading={loading} />
          </form>
        )}
      </div>
    </div>
  );
}
